import React from "react";
import Layout from "@/components/Layout";
import { ScrollFade, HeroStaggerText } from "@/lib/animations";

export default function Terms() {
  return (
    <Layout>
      <section className="bg-[#163A2F] text-[#F8F6F0] grain relative pt-20 pb-16 md:pt-28 md:pb-20 overflow-hidden">
        <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24">
          <div className="overline text-[#C9A227]">Legal</div>
          <HeroStaggerText
            text="Terms & Conditions"
            className="mt-3 text-4xl md:text-6xl font-extralight tracking-tight"
          />
          <p className="mt-4 text-[#F8F6F0]/70 font-light text-sm tracking-wider">Last updated: 10 February 2026</p>
        </div>
      </section>

      <section className="bg-[#F8F6F0] py-16 md:py-20" data-testid="terms-page">
        <div className="max-w-3xl mx-auto px-6 md:px-10 text-[#163A2F] font-light leading-relaxed space-y-8">
          <ScrollFade>
            <p>
              Welcome to Norbu Collection. By accessing or purchasing from <a href="https://norbu.in" className="text-[#C9A227] underline">norbu.in</a> you agree to these Terms &amp; Conditions. Please read them carefully.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">1. About us</h2>
            <p className="mt-3 text-[#163A2F]/85">
              Norbu Collection is a direct-to-customer menswear brand operated from New Delhi, India. All references to "we", "us" or "our" mean Norbu Collection.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">2. Eligibility</h2>
            <p className="mt-3 text-[#163A2F]/85">
              You must be at least 18 years old, or have the consent of a parent or guardian, to buy from this site. By placing an order you confirm that the information you provide is accurate.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">3. Products, pricing &amp; availability</h2>
            <ul className="mt-3 list-disc pl-5 space-y-2 text-[#163A2F]/85">
              <li>All prices are listed in Indian Rupees (INR) and are inclusive of applicable GST unless stated otherwise.</li>
              <li>Fabric colours may vary slightly from screen renders due to monitor and lighting differences.</li>
              <li>We reserve the right to limit quantities, correct pricing errors, or refuse any order at our discretion.</li>
              <li>Stock is updated in real time but in the rare event an item is unavailable after you order, we will refund you in full.</li>
            </ul>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">4. Order acceptance</h2>
            <p className="mt-3 text-[#163A2F]/85">
              Your order is a request to purchase. A contract is formed only when we send a dispatch confirmation. Until then we may cancel for reasons such as suspected fraud, incorrect pricing or out-of-stock inventory.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">5. Payments</h2>
            <p className="mt-3 text-[#163A2F]/85">
              Payments are processed securely through PayU. We accept major debit &amp; credit cards, UPI, net banking and wallets. We do not store your card details.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">6. Shipping, returns &amp; refunds</h2>
            <p className="mt-3 text-[#163A2F]/85">
              Delivery, return and refund terms are covered in our <a href="/shipping-policy" className="text-[#C9A227] underline">Shipping Policy</a> and <a href="/refund-policy" className="text-[#C9A227] underline">Refund &amp; Return Policy</a>. Both are part of these Terms.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">7. Intellectual property</h2>
            <p className="mt-3 text-[#163A2F]/85">
              All content on this site — brand name, logo, photography, product designs, copy — is owned by Norbu Collection or licensed to us. You may not reproduce or use it commercially without written permission.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">8. User accounts</h2>
            <p className="mt-3 text-[#163A2F]/85">
              You are responsible for keeping your account password confidential. Notify us immediately if you suspect unauthorised use of your account.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">9. Limitation of liability</h2>
            <p className="mt-3 text-[#163A2F]/85">
              Our liability for any order is limited to the amount paid for that order. We are not responsible for indirect or consequential losses, delays caused by courier partners, or acts beyond our reasonable control.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">10. Governing law</h2>
            <p className="mt-3 text-[#163A2F]/85">
              These Terms are governed by the laws of India. Any disputes will be subject to the exclusive jurisdiction of the courts of New Delhi.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">11. Changes</h2>
            <p className="mt-3 text-[#163A2F]/85">
              We may update these Terms occasionally. The latest version will always be posted on this page with a revised date.
            </p>
          </ScrollFade>

          <ScrollFade>
            <h2 className="text-xl md:text-2xl font-normal text-[#163A2F]">12. Contact</h2>
            <p className="mt-3 text-[#163A2F]/85">
              Questions? Write to <a href="mailto:support.norbucollection@gmail.com" className="text-[#C9A227] underline">support.norbucollection@gmail.com</a> or call +91 95609 95329.
            </p>
          </ScrollFade>
        </div>
      </section>
    </Layout>
  );
}
